import { emptySplitApi } from './index'

export const thankYouLetterApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getThankYouStepList: builder.query({
            query: () => ({
                url: `api/v1/document-generator-service/thank-you-letter/steps`,
                method: "GET"
            }),
        }),
        insertUpdateThankYouLetter: builder.mutation({
            query: (model) => ({
                url: `api/v1/document-generator-service/thank-you-letter`,
                method: "POST",
                body: model
            }),
        }),
        getThankYouLetter: builder.mutation({
            query: (userProjectId) => ({
                url: `api/v1/document-generator-service/thank-you-letter/${userProjectId}`,
                method: "GET",
            }),
        }),
    }),
    overrideExisting: false,
});

export const { 
    useGetThankYouStepListQuery,
    useInsertUpdateThankYouLetterMutation,
    useGetThankYouLetterMutation
} = thankYouLetterApi;
